import AplosModal from './AplosModal';

export default AplosModal;
